<template>
<div>

    <a ref="realLink" :href="link" style="display:none;">이동</a>
</div>
</template>

<script>
export default {
  computed:{
    link(){
      const path = this.$route.query.target;
      const encoded = encodeURIComponent(path);
      return  `openapp?target=${encoded}`;

    }
  },
  mounted(){
    this.$refs.realLink.click();
  }
}
</script>
